export default theme => ({
  container: {
    position: 'relative',
    background: '#272838',
  },
});
